// Author Liang Gang Qiang
// Date 2021-10-15 09:54:24

class ImfMstShiftTeamUser {
constructor({
        id = null,
        mstShiftTeamId = '',
        admUserId = '',
        admUserIdLoginName = '',
        remark = ''}
= {}) {
    this.id = id;
    this.mstShiftTeamId = mstShiftTeamId;
    this.admUserId = admUserId;
    this.admUserIdLoginName = admUserIdLoginName;
    this.remark = remark;
}
}

function newEntity() {
return new ImfMstShiftTeamUser();
}

    function gridFields() {
    return Object.freeze([
        {
        key: 'id',
        label: 'label.em.admin.imfMstShiftTeamUser.grid.id',
        sortable: true,
            isDetail: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'mstShiftTeamId',
        label: 'label.em.admin.imfMstShiftTeamUser.grid.mstShiftTeamId',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'admUserIdLoginName',
        label: 'label.em.admin.imfMstShiftTeamUser.grid.admUserIdLoginName',
        sortable: true,
        form: {
        type: 'input'
        }
        },
        {
        key: 'remark',
        label: 'label.em.admin.imfMstShiftTeamUser.grid.remark',
        sortable: true,
            isDetail: true,
        form: {
        type: 'textarea'
        }
        },
        {
        key: 'emAclDeptName',
        label: 'label.em.admin.imfMstShiftTeamUser.grid.emAclDeptName',
        sortable: true,
        form: {
        type: 'input'
        }
        }
    ])}

const filter = {
    idFilter : "",
    idListFilter : "",
    mstShiftTeamIdFilter : "",
    admUserIdFilter : "",
    admUserIdLoginNameFilter : "",
    emAclDeptIdFilter : "",
    emAclDeptNameFilter : "",
    emAclDeptNodeCodeFilter : "",
    emAclDeptNodeCodeNameFilter : ""
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
        {
        key: 'mstShiftTeamIdFilter',
        label: 'label.em.admin.imfMstShiftTeamUser.filter.mstShiftTeamId',
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'admUserIdLoginNameFilter',
        label: 'label.em.admin.imfMstShiftTeamUser.filter.admUserIdLoginName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
            ,fieldsBindingByEntityModalSelected: '{"admUserId":"id"}'
                }
        },
        {
        key: 'emAclDeptNameFilter',
        label: 'label.em.admin.imfMstShiftTeamUser.filter.emAclDeptName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptId":"id"}'
                }
        },
        {
        key: 'emAclDeptNodeCodeNameFilter',
        label: 'label.em.admin.imfMstShiftTeamUser.filter.emAclDeptNodeCodeName',
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclDept'
            ,correspondingField: 'name'
            ,fieldsBindingByEntityModalSelected: '{"emAclDeptNodeCode":"nodeCode"}'
                }
        }
];


    const entityFormConfigs = [
        {
        key: 'mstShiftTeamId',
        label: 'label.em.admin.imfMstShiftTeamUser.entity.mstShiftTeamId',
        sortable: true,
        disabled: false,
        form: {
        type: 'inputNumber'
                }
        },
        {
        key: 'admUserIdLoginName',
        label: 'label.em.admin.imfMstShiftTeamUser.entity.admUserIdLoginName',
        sortable: true,
        disabled: false,
        form: {
        type: 'entityModalSelect'
            ,entity: 'emAclUser'
            ,correspondingField: 'loginName'
            ,fieldsBindingByEntityModalSelected: '{"admUserId":"id"}'
                }
        },
        {
        key: 'remark',
        label: 'label.em.admin.imfMstShiftTeamUser.entity.remark',
        sortable: true,
        disabled: false,
        form: {
        type: 'textarea'
                }
        }
]

export {ImfMstShiftTeamUser, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
, filterConfigs


}
